<template>
    <div class="A4-land">
        <div class="row">
            <div class="col-sm-12">
                <div class="print-header">
                    <h4 class="text-center font-m">{{$t('expense_on_cost')}}</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-sm table-striped no-bor">
                    <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                            <th>{{$t('date')}}</th>
                            <th>{{$t('item_code')}}</th>
                            <th>{{$t('item_name')}}</th>
                            <th>{{$t('invoice_no')}}</th>
                            <th>{{$t('customer')}}</th>
                            <th class="text-center">{{$t('cost')}}</th>
                            <th class="text-center">{{$t('qty')}}</th>
                            <th class="text-right">{{$t('amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                            <td>{{ret.ItemCode}}</td>
                            <td>{{ret.ItemName}}</td>
                            <td>{{ret.InvoiceNum}}</td>
                            <td>{{ret.CustomerName}}</td>
                            <td class="text-right">{{$money(ret.Cost)}}</td>
                            <td class="text-center">{{ret.Quantity}}</td>
                            <td class="text-right">{{$money(ret.TotalCost)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="8" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(total)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1
                },
                records:[],
                total: 0
            }
        },
        created: function(){
            let linkQuery = this.$route.query;
            if(linkQuery.year != undefined && linkQuery.year != null && linkQuery.year != ''){
                this.query.Year = linkQuery.year;
            }
            if(linkQuery.month != undefined && linkQuery.month != null && linkQuery.month != ''){
                this.query.Month = linkQuery.month;
            }
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('report/expense/cost', this.query).then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.CostLines;
                        this.total = res.data.Json.TotalCost;
                    }
                }).finally(function() { loading.hide(); });
            }
        }
    }
</script>